import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

import { setExportFileFormat } from '../../actions/rldToolActions';
import CommonDropdown from '../common/CommonDropdown';
import { RldConstant } from './RldConstant';

const RldExportFileFormat = () => {
  const columnSeperator = useSelector(({ rldTool }) => rldTool.columnSeperator);
  const dispatch = useDispatch();

  const [selectedExport, setSelectedExport] = useState(null);

  useEffect(() => {
    const exportFormat = _.find(RldConstant.exportFormats, {
      value: columnSeperator,
    });
    setSelectedExport(exportFormat);
  }, [columnSeperator]);

  const changeExportFormat = e => {
    dispatch(setExportFileFormat(e.value));
  };

  return (
    <div className="accountpositioning">
      <div className="account_component">
        <div className="account_selector">
          <div className="account_item export_format">
            <CommonDropdown
              listData={RldConstant.exportFormats}
              defaultSelected={selectedExport}
              itemClickFn={changeExportFormat}
              filterSearch={false}
              placeHolder="Select Export Format"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default RldExportFileFormat;
